import { List as ImmutableList } from 'immutable';
import { BulkAnonymizationModes } from '../constants-types/Enums';
import { List } from '../constants-types/PiList.model';

export enum AnonymizationOptions {
    bulkAnonymize = 'bulkAnonymize',
    anonymizeByPerson = 'anonymizeByPerson'
}

export enum BulkAnonymizationRangeOptions {
    allMatchingRecords = 'allMatchingRecords',
    basedOnDateRange = 'basedOnDateRange'
}

export class AnonymizationOption {
    type: AnonymizationOptions;
    translationKey: string;
}

export class BulkAnonymizationConfiguration {
    bulkAnonymizationMode: BulkAnonymizationModes;
    anonymizeCandidates: boolean;
    anonymizeFormerEmployees: boolean;
    anonymizeUnknown: boolean;
    anonymizeOther: boolean;
    bulkAnonymizationRangeOptions: BulkAnonymizationRangeOptions;
    anonymizationAfterDaysRange: number;
}

export class AnonymizationTargetCount {
    anonymizeCandidateCount: number;
    anonymizeFormerEmployeeCount: number;
    anonymizeUnknownCount: number;
    anonymizeOtherCount: number;
}

export const AnonymizationOptionBasics: List<AnonymizationOption> =
    ImmutableList([
        {
            type: AnonymizationOptions.anonymizeByPerson,
            translationKey: 'anonymization.types.anonymizeByPerson'
        },
        {
            type: AnonymizationOptions.bulkAnonymize,
            translationKey: 'anonymization.types.bulkAnonymize'
        }
    ]);
